export interface ImageBase64 {
    data: string
    height: number
    width: number
}

export interface PdfRenderProperties {
    span: string
    spanDepth: string
    depthPerInch: number
    timePerInch: number
}

export enum RangeSpanType {
    NONE = 'NONE',
    DEPTH = 'DEPTH',
    TIME = 'TIME'
}
export interface RangeSpan {
    ticks: number
    start: number
    range: number
    interval: number
    end: number
    active: boolean
    type: RangeSpanType
}
export interface CropItem {
    ticksTime: number
    ticksDepth: number
    startSpan: number
    endSpan: number
    startSpanDepth: number
    endSpanDepth: number
    tickStartPosition:number
}
export interface PagePDF {
    ticks: number
    crops: CropItem[]
}
export interface PdfRender {
    numberOfCrops: number
    totalTicks: number
    crops: CropItem[]
    rangeTime: RangeSpan
    rangeDepth: RangeSpan
}
